import { Select } from 'antd';

import type { NClients } from '@app/types';

import { AdaptedFilter } from '@pages/Clients/ClientsList/components/Filters/AdaptedFilter';

export const AdaptedSelect = ({
  filterElements,
  placeholder,
  memoizedFilterStyles,
}: {
  filterElements: NClients.GeneralFilterItem[];
  placeholder: JSX.Element;
  memoizedFilterStyles: {
    width: string;
    minWidth: number;
  };
}) => {
  return (
    <Select
      placeholder={placeholder}
      popupRender={() => <AdaptedFilter filterElements={filterElements} />}
      style={memoizedFilterStyles}
      popupMatchSelectWidth={false}
    />
  );
};
